import React from 'react';
import format from '../../../shared/format';
import { AcquireStatus, Default, StartBeforeType, RequirementInfo } from '../constants';

function RequirementInfoContent({ type, data }) {
    return (
        <table
            cellPadding='0'
            cellSpacing='0'
            className="distribute"
            style={{padding: 10, border: '1px solid #D1D1D1', borderRadius: 3}}
        >
                <tbody>
                    {
                        type === "before" &&
                        <tr>
                            <td className="distribute_td_left">启动前类型：</td>
                            <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>{StartBeforeType[data.requirementInfoType]}</td>
                        </tr>
                    }
                    <tr>
                        <td className="distribute_td_left">人员要求：</td>
                        <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>{data.comment}</td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">预计上岗时间：</td>
                        <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>{format('date', data.planOnDutyTime)}</td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">预计/实际启动时间：</td>
                        <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>{format('date', data.planStartupTime)}</td>
                    </tr>
                </tbody>
        </table>
    );
}

function RequirementInformation({ data, piList }) {
    const piNames = piList.map(i => format('joint', i.userCompellation, i.userMobile, 'roundBrackets')).join('，');
    const requirementInfos = data.requirementInfos;
    const requirementInfoKeys = Object.keys(requirementInfos || {});
    return (
        <div style={{ marginBottom: 20 }}>
            <table cellPadding='0' cellSpacing='0' className="distribute">
                <tbody>
                    <tr>
                        <td className="distribute_td_left">需求编号：</td>
                        <td className="distribute_td_right">{data.requirementCode}</td>
                        <td className="distribute_td_left">需求发起人：</td>
                        <td className="distribute_td_right">{format('joint', data.requireUser, data.requireUserCode, 'roundBrackets')}</td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">中心名称（中心编号）：</td>
                        <td className="distribute_td_right">{data.investigationSiteName}</td>
                        <td className="distribute_td_left">城市：</td>
                        <td className="distribute_td_right">{data.city}</td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">院区：</td>
                        <td className="distribute_td_right">{data.courtyardArea}</td>
                        <td className="distribute_td_left">科室：</td>
                        <td className="distribute_td_right">{data.departmentName}</td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">PI：</td>
                        <td className="distribute_td_right">{piNames}</td>
                        <td className="distribute_td_left">项目获得状态：</td>
                        <td className="distribute_td_right">
                            {AcquireStatus[data.investigationAcquisitionStatus]}
                        </td>
                    </tr>
                    <tr>
                        <td className="distribute_td_left">需求类型：</td>
                        <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>
                            {
                                requirementInfoKeys.map(item => (
                                    <div key={item}>
                                        <div style={{ minHeight: 24 }}>{RequirementInfo[item]}</div>
                                        <RequirementInfoContent type={item} data={requirementInfos[item] || {}} />
                                    </div>
                                ))
                            }
                        </td>
                    </tr>
                    {
                        requirementInfoKeys.length > 1 &&
                        <tr>
                            <td className="distribute_td_left">启动前后是否要求同一人：</td>
                            <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>
                                {Default[data.afterBeforeStartupSameMember]}
                            </td>
                        </tr>
                    }
                    <tr>
                        <td className="distribute_td_left">目前项目进度：</td>
                        <td className="distribute_td_right" colSpan="3" style={{ width: '80%' }}>
                            {data.currentInvestigationProgress}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default RequirementInformation;


// WEBPACK FOOTER //
// ./src/components/user/require/components/RequirementInformation.js